import React, { Component } from 'react';
import {Bar} from 'react-chartjs-2';
var classNames = require('classnames');

class BarChart extends Component{
  render() {
    const styles = this.props.styles;
    const data = this.props.data;
    var monthArray = [];
    var totalsArray = [];
    for (let index = 0; index < data.length; index++) {
      monthArray.push(
        "Monat " + data[index].month
      )
      totalsArray.push(
        data[index].sum
      )
    }
    const colors = totalsArray.map((value) => value < 0 ? '#0D2EA0' : 'rgba(125,156,94,1)');
    const testData = {
      labels: monthArray,
      datasets: [{
        data: totalsArray,
        barThickness: 8,
        borderColor: colors,
        backgroundColor: colors
      }]
    }
    const chartOptions = {
      legend: {
        display: false
      },
      scales:
      {
        xAxes: [{
            display: false
        }],
        yAxes: [{
          display: false,
        }],
      },
      datasets: [{
        barThickness: 8
      }]

    }
    return(
      <div className={classNames(styles.inputItem, styles.modulGraph)}>
        <section>
          <Bar data={testData} options={chartOptions} height={171} />
        </section>
      </div>
    );
  }
}

export default BarChart;



// WEBPACK FOOTER //
// ./src/components/calculator/charts/c_bar_chart.js